class ItemRemoveButton extends HTMLElement {
  connectedCallback() {
    this.key = this.dataset.key;
    if (!this.key) return;
    this.addEventListener("click", () => this.removeItem(0));
  }

  async removeItem(newQuantity) {
    try {
      this.disabled = true;
      window.dispatchEvent(new CustomEvent("cart:cart-loader"));

      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          updates: {
            [this.key]: newQuantity,
          },
        }),
      });

      if (!res.ok) {
        console.error("Cart update failed");
        return;
      }

      const cart = await res.json();

      const FREEBIE_VARIANT_ID = window.FREEBIE_CONFIG?.variantId
        ? Number(window.FREEBIE_CONFIG.variantId)
        : null;

      if (
        FREEBIE_VARIANT_ID &&
        cart.items.length === 1 &&
        (Number(cart.items[0].variant_id) === FREEBIE_VARIANT_ID ||
          Number(cart.items[0].id) === FREEBIE_VARIANT_ID)
      ) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            updates: {
              [cart.items[0].key]: 0,
            },
          }),
        });
      }

      window.dispatchEvent(
        new CustomEvent("cart:count-update", {
          detail: {
            count: cart.item_count,
          },
        })
      );

      this.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
    } catch (err) {
      console.error("Error updating cart:", err);
    } finally {
      this.disabled = false;
    }
  }
}

customElements.define("item-remove-button", ItemRemoveButton);
